module.exports = __webpack_public_path__ + "img/truedamage_giants.a387137c.jpg";